import React from "react";
import DOMPurify from "dompurify";

import * as styles from "./styles.module.css";

type Props = {
    marketingLongDescription: string;
}

export function ProductDescription({ marketingLongDescription }: Props) {
    const cleanHtml = DOMPurify.sanitize(marketingLongDescription);

    return (
        <div
            className={styles.container}
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: cleanHtml }}
        />
    );
}
